import DetailService from '../../components/DetailService';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

function BaseDeDonnees() {
    return (
         <div>
            <Header/>
        <DetailService
            titre="Création et refonte de base de données"
            categorie="Ingénierie"
            image="/images/ingenierie.avif"
            description="Nous concevons et optimisons vos bases de données pour une récupération rapide et efficace des informations. Nous en assurons également la maintenance et la surveillance afin de prévenir les ralentissements et garantir leur performance. Enfin, nous les intégrons directement à vos projets pour une gestion fluide et adaptée à vos besoins."
            etapes={[
                {
                    numero: 1,
                    titre: 'Cadrage et analyse des besoins',
                    texte: 'Identification des besoins métiers et techniques : volumes de données, types de requêtes, contraintes de performance et d\'intégration avec les systèmes existants.',
                },
                {
                    numero: 2,
                    titre: 'Audit de l\'existant',
                    texte: 'Analyse de la base de données actuelle — structure, performances, points de blocage — afin d\'établir un état des lieux objectif et d\'identifier les axes d\'amélioration prioritaires.',
                },
                {
                    numero: 3,
                    titre: 'Conception du modèle de données',
                    texte: 'Définition du schéma relationnel ou NoSQL optimisé pour vos usages : modélisation entités-relations, indexation, normalisation et choix technologique adapté à vos contraintes.',
                },
                {
                    numero: 4,
                    titre: 'Développement et migration',
                    texte: 'Implémentation de la nouvelle architecture et transfert sécurisé des données existantes, sans perte ni interruption de service. Des tests rigoureux valident chaque étape de la migration.',
                },
                {
                    numero: 5,
                    titre: 'Optimisation et livraison',
                    texte: 'Tuning des performances (requêtes, index, cache), documentation technique et livraison finale avec accompagnement à la prise en main de la nouvelle solution.',
                },
            ]}
            realisations={[
               
            ]}
        />
        <Footer/>
        </div>
    );
}

export default BaseDeDonnees;
